import columns from "./columns";
import searchFields from "./searchFields";
import formFields from "./formFields";
import previewFields from "./previewFields";

export default {
    entityName: "truckTypes",
    pageTitle: "Truck Types",
    columns,
    searchFields,
    searchPlaceholder: "e.g. box:open, condition:colman",
    formFields,
    previewFields,
    tableOptions: { hideSearch: true },
    formOptions: {},
};
